import { render, staticRenderFns } from "./addGood.vue?vue&type=template&id=701c30ea&"
import script from "./addGood.vue?vue&type=script&lang=js&"
export * from "./addGood.vue?vue&type=script&lang=js&"
import style0 from "./addGood.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports